import { useContext, useEffect } from "react";
import { Button } from "react-bootstrap";
import AuthContext from "@/shared/context/auth-context";
import useHttp from "@/shared/hooks/use-http";
import { getAllData } from "@/shared/utils/api";
import { validateLoadingStatusNew, createUUID } from "@/shared/utils/utils";
import "./datamodel-page.scss";
import Spinner from "@/shared/components/spinner/spinner";
import ReferencingComponentConfiguration from "./referencing-component-configuration";
import { useParams } from "react-router";

interface IDatamodelReferencingComponentTab {
  datamodelFields: {
    id: string;
    field_name: string;
    field_datatype: string;
  }[];
  referencingComponents: IDatamodelRelation[];
  datamodelType: string;
  onReferencingComponentsChange: (components: IDatamodelRelation[]) => void;
}

export interface IDatamodelRelation {
  id: string;
  grouping_id: string;

  source_datamodel_id: string;
  source_type: string;

  target_datamodel_id: string;
  target_type: string;

  relations: {
    source_field_id: string;
    target_field_id: string;
  }[];
}

const ReferencingComponentTab = ({ datamodelFields, referencingComponents, onReferencingComponentsChange, datamodelType }: IDatamodelReferencingComponentTab) => {
  const authCtx = useContext(AuthContext);
  const params = useParams();

  const { sendRequest: getDatamodels, data: getDatamodelsData, status: getDatamodelsStatus } = useHttp(
    getAllData,
    false,
    authCtx.token,
    undefined,
    "platform"
  );

  useEffect(() => {
    if (datamodelType === "event"){
      getDatamodels("list_datamodels?link=false");
    } else {
      getDatamodels("list_datamodels?link=false&entity_only=true");
    }
  
  }, [datamodelType]);

  useEffect(() => {
    if (!params.id) {
      onReferencingComponentsChange([
        {
          id: createUUID(),
          grouping_id: "",
          source_datamodel_id: "",
          source_type: "",
          target_datamodel_id: "",
          target_type: "",
          relations: []
        }
      ]);
    }
  }, [params.id]);

  const handleAddRelation = () => {
    onReferencingComponentsChange([
      ...referencingComponents,
      {
        id: createUUID(),
        grouping_id: createUUID(),
        source_datamodel_id: "",
        source_type: "",
        target_datamodel_id: "",
        target_type: "",
        relations: []
      }
    ]);
  };

  const handleRemoveRelation = (id: string) => {
    onReferencingComponentsChange(referencingComponents.filter(r => r.id !== id));
  };

  const handleUpdateRelation = (update: IDatamodelRelation) => {
    onReferencingComponentsChange(referencingComponents.map(rel =>
      rel.id === update.id
        ? { ...rel, ...update }
        : rel
    ));
  };

  return <div className="datamodel-referencing-component-tab">
    {validateLoadingStatusNew([
      getDatamodelsStatus,
    ]) && <Spinner />}

    {referencingComponents.map(relation => (
      <ReferencingComponentConfiguration
        key={relation.id}
        onRemove={handleRemoveRelation}
        onUpdate={handleUpdateRelation}
        datamodels={getDatamodelsData?.rows || []}
        currentDatamodelFields={datamodelFields}
        datamodelRelation={relation}
      />
    ))}

    <Button
      variant="primary"
      onClick={handleAddRelation}
    >
      + Add new relation
    </Button>
  </div>
};

export default ReferencingComponentTab;
